/* eslint-disable */ /**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 * instead, edit its related `.gql` file and recreate it with
 *
 * npm run codegen:mentor
 */

import * as Types from '../../types/mentor-gql';

import { api } from 'app/apis/mentor-gql-api';
export type MentorDash_UpdateMentorMutationVariables = Types.Exact<{
  uid: Types.Scalars['String']['input'];
  phone_number?: Types.InputMaybe<Types.Scalars['String']['input']>;
  bio?: Types.InputMaybe<Types.Scalars['String']['input']>;
  github_url?: Types.InputMaybe<Types.Scalars['String']['input']>;
  linkedin_url?: Types.InputMaybe<Types.Scalars['String']['input']>;
  avatar_url?: Types.InputMaybe<Types.Scalars['String']['input']>;
  agreement_version?: Types.InputMaybe<Types.Scalars['String']['input']>;
  available_hours?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  languages?: Types.InputMaybe<
    Array<Types.InputMaybe<Types.Scalars['String']['input']>> | Types.InputMaybe<Types.Scalars['String']['input']>
  >;
  timezone?: Types.InputMaybe<Types.Scalars['String']['input']>;
  application?: Types.InputMaybe<Types.Scalars['JSON']['input']>;
  gov_mentor_agreement_version?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;

export type MentorDash_UpdateMentorMutation = {
  __typename?: 'Mutation';
  updateMentor?: {
    __typename?: 'Mentor';
    phone_number?: string | null;
    bio?: string | null;
    github_url?: string | null;
    linkedin_url?: string | null;
    avatar_url?: string | null;
    agreement_version?: string | null;
    available_hours?: number | null;
    languages?: Array<string | null> | null;
    timezone?: string | null;
    application?: any | null;
    gov_mentor_agreement_version?: string | null;
  } | null;
};

export const MentorDash_UpdateMentorDocument = `
    mutation MentorDash_UpdateMentor($uid: String!, $phone_number: String, $bio: String, $github_url: String, $linkedin_url: String, $avatar_url: String, $agreement_version: String, $available_hours: Int, $languages: [String], $timezone: String, $application: JSON, $gov_mentor_agreement_version: String) {
  updateMentor(
    uid: $uid
    phone_number: $phone_number
    bio: $bio
    github_url: $github_url
    linkedin_url: $linkedin_url
    avatar_url: $avatar_url
    agreement_version: $agreement_version
    available_hours: $available_hours
    languages: $languages
    timezone: $timezone
    application: $application
    gov_mentor_agreement_version: $gov_mentor_agreement_version
  ) {
    phone_number
    bio
    github_url
    linkedin_url
    avatar_url
    agreement_version
    available_hours
    languages
    timezone
    application
    gov_mentor_agreement_version
  }
}
    `;

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    MentorDash_UpdateMentor: build.mutation<MentorDash_UpdateMentorMutation, MentorDash_UpdateMentorMutationVariables>({
      query: (variables) => ({ document: MentorDash_UpdateMentorDocument, variables }),
    }),
  }),
});

export { injectedRtkApi as api };
